import { type FC, type ReactElement } from 'react';
import classnames from 'classnames';

import Circle from 'dibs-icons/exports/legacy/Circle.ts';
import { Link } from 'dibs-elements/exports/Link.tsx';

import styles from './styles/CarouselDot.scss';

const Dot: FC<{ isActive?: boolean }> = ({ isActive }) => (
    <Circle
        className={classnames(styles.dot, styles.highSpecificity, { [styles.active]: isActive })}
    />
);

export const CarouselDot: FC<{ onClick?: () => void; isActive?: boolean; label?: string }> = ({
    onClick,
    isActive,
    label,
}) => {
    return onClick ? (
        <Link ariaLabel={label} onClick={onClick}>
            <Dot isActive={isActive} />
        </Link>
    ) : (
        <Dot isActive={isActive} />
    );
};
type RenderDotArgs = {
    isCurrentDot?: boolean;
    pageIndex?: number;
};
// for easy use with dibs-carousel
export const renderDot = ({ isCurrentDot }: RenderDotArgs = {}): ReactElement => (
    <CarouselDot isActive={isCurrentDot} />
);
